<template>
  <div class="app-container" id="main">
    <table>
      <tr class="title font-bold">
        <td colspan="11">以旧换新旧机结算单（T+7）</td>
      </tr>
      <tr>
        <td class="title">结算单编号</td>
        <td colspan="11">{{ settleData.settlementNo }}</td>
      </tr>
      <tr>
        <td class="title">承运商</td>
        <td colspan="3">{{ settleData.transportCompany }}</td>
        <td class="title">旧机归属销司</td>
        <td colspan="6">{{ settleData.saleCompanyName }}</td>
      </tr>
      <tr>
        <td class="title">渠道</td>
        <td colspan="3">{{ settleData.salePlatformName }}</td>
        <td class="title">承运单位</td>
        <td colspan="6">{{ settleData.orgName }}</td>
      </tr>
      <tr class="title">
        <td rowspan="2">材料名称</td>
        <td rowspan="2">规格</td>
        <td rowspan="2">单位</td>
        <td rowspan="2">实收数</td>
        <td rowspan="2">实收连接管长度（米）</td>
        <td rowspan="2" width="20%">旧机编码</td>
        <td rowspan="2" width="20%">回收订单</td>
        <td colspan="3">结算数据</td>
      </tr>
      <tr class="title">
        <td>旧机价（含税13%）</td>
        <td>连接管价（含税13%）</td>
        <td>结算金额（含税13%）</td>
      </tr>
      <tr v-for="(item, index) in settleData.detailRespList" :key="index">
        <td
          v-if="index === 0"
          :rowspan="settleData.detailRespList.length"
          class="title"
        >
          {{ settleData.materialName }}
        </td>
        <td>{{ item.specName }}</td>
        <td class="title">套</td>
        <td>{{ item.readNum }}</td>
        <td>
          <div>铜管：{{ item.copperTubeLength }}</div>
          <div>铝管：{{ item.aluminumTubeLength }}</div>
        </td>
        <td class="bar-code-wrap">{{ item.oldBarcode }}</td>
        <td class="bar-code-wrap" >{{ item.recycleNoStr }}</td>

        <td>{{ item.oldMachinePrice }}</td>
        <td>{{ item.realCopperPipePrice }}</td>
        <td>{{ item.settlementPrice }}</td>
      </tr>
      <tr>
        <td colspan="3" class="title">小计</td>
        <td>{{ settleData.totalReadCount }}</td>
        <td>
          <div>铜管：{{ settleData.totalCopperTubeLength }}</div>
          <div>铝管：{{ settleData.totalAluminumTubeLength }}</div>
        </td>
        <td></td>
        <td></td>

        <td>{{ settleData.totalOldMachinePrice }}</td>
        <td>{{ settleData.totalRealCopperPipePrice }}</td>
        <td>{{ settleData.totalSettlementPrice }}</td>
      </tr>
      <tr>
        <td colspan="11" class="title font-bold">旧机质检扣款</td>
      </tr>
      <tr class="title">
        <td>名称</td>
        <td>质检项</td>
        <td>单位</td>
        <td colspan="2">需扣款数</td>
        <td colspan="6">扣款结算（含税13%）</td>
      </tr>
      <tr>
        <td class="title" rowspan="13">质检扣款</td>
      </tr>
      <tr>
        <td class="title">大阀门</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualBigValveCount }}</td>
        <td colspan="6">{{ settleData.actualBigValvePrice }}</td>
      </tr>
      <tr>
        <td class="title">小阀门</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualSmallValveCount }}</td>
        <td colspan="6">{{ settleData.actualSmallValvePrice }}</td>
      </tr>
      <tr>
        <td class="title">外机风叶</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualExWindBladeCount }}</td>
        <td colspan="6">{{ settleData.actualExWindBladePrice }}</td>
      </tr>
      <tr>
        <td class="title">内机风叶</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualInWindBladeCount }}</td>
        <td colspan="6">{{ settleData.actualInWindBladePrice }}</td>
      </tr>
      <tr>
        <td class="title">内机电机</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualInElectricalMachineryCount }}</td>
        <td colspan="6">{{ settleData.actualInElectricalMachineryPrice }}</td>
      </tr>
      <tr>
        <td class="title">外机电机</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualExElectricalMachineryCount }}</td>
        <td colspan="6">{{ settleData.actualExElectricalMachineryPrice }}</td>
      </tr>
      <tr>
        <td class="title">内机面板</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualInternalPanelCount }}</td>
        <td colspan="6">{{ settleData.actualInternalPanelPrice }}</td>
      </tr>
      <tr>
        <td class="title">外机外罩</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualExCoverCount }}</td>
        <td colspan="6">{{ settleData.actualExCoverPrice }}</td>
      </tr>
      <tr>
        <td class="title">外机顶板/底板</td>
        <td class="title">个</td>
        <td colspan="2">{{ settleData.actualExBoardCount }}</td>
        <td colspan="6">{{ settleData.actualExBoardPrice }}</td>
      </tr>
      <tr>
        <td class="title">电源线</td>
        <td class="title">根</td>
        <td colspan="2">{{ settleData.actualPowerLineCount }}</td>
        <td colspan="6">{{ settleData.actualPowerLinePrice }}</td>
      </tr>
      <tr>
        <td class="title" colspan="4">扣款小计</td>
        <td colspan="5">{{ settleData.totalActualPrice }}</td>
      </tr>
      <tr>
        <td class="title" colspan="4">合计</td>
        <td colspan="5">{{ settleData.actualPrice }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { downSettlementList } from "@/api/oldForNew";
export default {
  name: "searchOldDetail",
  components: {},
  data() {
    return {
      params: {
        salePlatformType: this.$route.query.salePlatformType,
        transportCompanyNo: this.$route.query.transportCompanyNo,
        regionNo: this.$route.query.regionNo,
        startAppraisalTime: this.$route.query.startAppraisalTime
          ? this.$route.query.startAppraisalTime + " 00:00:00"
          : "",
        endAppraisalTime: this.$route.query.endAppraisalTime
          ? this.$route.query.endAppraisalTime + " 23:59:59"
          : "",
        sourceWorkOrderNo: this.$route.query.sourceWorkOrderNo|| null,
        sendBackOrderId: this.$route.query.sendBackOrderId || null,
        settlementStatus: 1,
        startRecoveryCompleteDate: this.$route.query.startRecoveryCompleteDate
          ? this.$route.query.startRecoveryCompleteDate + " 00:00:00"
          : "",
        endRecoveryCompleteDate: this.$route.query.endRecoveryCompleteDate
          ? this.$route.query.endRecoveryCompleteDate + " 23:59:59"
          : "",
        startCreatedDate: this.$route.query.startCreatedDate
          ? this.$route.query.startCreatedDate + " 00:00:00"
          : "",
        endCreatedDate: this.$route.query.endCreatedDate
          ? this.$route.query.endCreatedDate + " 23:59:59"
          : "",
      },
      settleData: {},
      printFlag: true
    };
  },
  mounted() {
    this.getPrintDetail();
  },
  methods: {
    async getPrintDetail() {
      console.log('dasd',this.$route)
      let { statusCode, data } = await downSettlementList(this.params);
      if (statusCode === 200) {
        this.settleData = data;
        this.printDetail();
      } else {
        this.$message.warning({
          message: "暂无结算单数据"
        });
      }
    },
    printDetail() {
      //获取原有页面的html内容
      let timer = setTimeout(() => {
        let oldStr = window.document.body.innerHTML;
        //根据id获取打印的html内容
        let newStr = document.getElementById("main").innerHTML;
        //html页面内容赋值
        window.document.body.innerHTML = newStr;
        //调用打印弹窗
        // window.print();
        // if (this.printFlag) {
        //   this.printFlag = false;
        //   this.$router.push({
        //     path: "/oldForNewService/searchOld"
        //   });
        // } else {
        //   //页面内容还原
        //   window.document.body.innerHTML = oldStr;
        //   // window.location.reload()
        // }
        // //打印完成后重新加载页面
        // window.location.reload();
        clearTimeout(timer);
      }, 500);
    },
    //返回
    goReturn() {
      this.$router.back(-1);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
td {
  border: 1px solid #aaaaaa;
  padding: 8px;
  font-size: 12px;
  &.bar-code-wrap {
    width: 20%;
    word-wrap: break-word;
    overflow-wrap: anywhere;
  }
}
.title {
  text-align: center;
}
.font-bold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/searchOldDetail.vue